import React, { useState } from 'react';
import { Avatar, Box, Card, CardContent, Typography, IconButton } from '@mui/material';
import { People, AttachMoney, DeleteOutline, MonetizationOnRounded, Delete } from '@mui/icons-material';
import { Classroom } from '../../../models/classroom';
import renderAvatar from '../../../components/render-avatar';
import DeleteClassroomDialog from './delete-classroom-dialog';
import { useClassroomActions } from '../../../hooks/useClassroomActions';

interface ClassroomItemProps {
  classroom: Classroom;
}

const ClassroomItem: React.FC<ClassroomItemProps> = ({ classroom }) => {
    const { deleteClassroom } = useClassroomActions();

    const [deleteClassroomDialog, setDeleteClassroomDialog] = useState(false);

    const handleDeleteClassroom = (password: string) => {
        deleteClassroom(classroom.id, password);
    };

    return (
        <Card
            sx={{
                width: '100%',
                textAlign: 'left',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                transition: 'all 0.2s ease-in-out',
                cursor: 'pointer',
            }}
            elevation={0}
        >
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

                    {renderAvatar(classroom.id, classroom.name, classroom.image, 40, 48)}

                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: 600,
                                fontSize: '0.9rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {classroom.name}
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary',
                                    fontWeight: 500,
                                    display: 'flex',
                                    alignItems: 'center', 
                                    gap: 0.5
                                }}
                            >
                                <People sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                                
                                {classroom.enrollment_count || 0}
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'success.main',
                                    fontWeight: 600,
                                }}
                            >
                                {`₦ ${classroom.earnings.toLocaleString()}`}
                            </Typography>
                        </Box>
                    </Box>
                    
                    <IconButton
                        onClick={() => setDeleteClassroomDialog(true)}
                        sx={{
                            color: 'red',
                            '&:hover': {
                                color: 'error.main',
                                backgroundColor: 'error.light',
                            },
                            transition: 'all 0.2s ease-in-out',
                        }}
                        >
                        <Delete />
                    </IconButton>
                </Box>
            </CardContent>

            <DeleteClassroomDialog
                open={deleteClassroomDialog}
                setOpen={setDeleteClassroomDialog}
                deleteFunction={handleDeleteClassroom}
            />
        </Card>
    );
};

export default ClassroomItem;